// extracted by mini-css-extract-plugin
export default {"line-break":"LineBreak_line-break__8q6OV"};